import { SliderBlogs } from '@/component/Slider';
import { SearchBlogs, HOME_OWNERS_SLUG } from '@/query';

import { usePostsSlider } from './usePostsSlider';

export const HomeOwnersPosts = (props) => {
  const { called, posts, handleNext, loading, metadata } = usePostsSlider({
    placement: HOME_OWNERS_SLUG,
    query: SearchBlogs,
  });

  return called && posts?.length ? (
    <SliderBlogs
      classesHeader="lg:!pt-16"
      classesSlider="lg:!pb-24"
      items={posts}
      onLoadMore={handleNext}
      loading={loading}
      hasNextPage={metadata.hasNextPage}
      widthLarge
      {...props}
    />
  ) : null;
};
